import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IContainedFilter {
  filterId: string;
  filterType: string;
}

export type MultiFilterState = {
  moreFilters: IContainedFilter[];
};

const initialState: MultiFilterState = {
  moreFilters: [],
};

const multiFilterSlice = createSlice({
  name: 'multifilter',
  initialState,
  reducers: {
    setContainedFilters: (state: MultiFilterState, action: PayloadAction<MultiFilterState>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { setContainedFilters } = multiFilterSlice.actions;
export const multiFilterReducer = multiFilterSlice.reducer;
